<script lang="ts">

/**
 * VDataGridActionBarV2 — декларативный компонент панели действий
 *
 * Отображается внизу таблицы когда есть выбранные строки.
 * Доступная переменная: selectedRows
 *
 * @example
 * <VDataGridActionBarV2>
 *   Выбрано {{ selectedRows.length }} строк
 *   <VButton @click="doSomething">Действие</VButton>
 * </VDataGridActionBarV2>
 *
 * @example отключение
 * <VDataGridActionBarV2 :disabled="isShipped ? 'Сборка уже отгружена' : null">...</VDataGridActionBarV2>
 *   — строка: класс disabled + tooltip с причиной
 *   — true: класс disabled без tooltip'а
 *   — null/false: рабочее состояние
 *
 * @example модификаторы и пользовательские классы
 * <VDataGridActionBarV2 class="centered">...</VDataGridActionBarV2>
 *   — class пробрасывается на сам контейнер action-bar в DOM.
 *   — известные модификаторы: .centered (центровка по горизонтали).
 */
export default defineComponent({
  name: 'VDataGridActionBarV2',

  props: {
    /**
     * Отключить панель действий. Сама панель остаётся на месте, но визуально
     * приглушена (opacity 0.5) и не реагирует на клики (pointer-events: none у детей).
     * Если передана строка — она показывается тултипом при наведении (подсказка причины).
     * Если true — тултипа нет, но панель отключена.
     * Если null/false — обычное активное состояние.
     */
    disabled: {
      type:    [String, Boolean] as PropType<string | boolean | null>,
      default: null,
    },
  },

  render() {
    return null;
  },
});
</script>